const policyBody = document.querySelector(".shopify-policy__body");

if (policyBody) {
  const summary = document.createElement("div");
  summary.classList.add("shopify-policy__summary");

  const summaryList = document.createElement("ul");
  summary.appendChild(summaryList);

  const allTitles = document.querySelectorAll(".shopify-policy__body h2");

  if (allTitles.length !== 0) {
    allTitles.forEach((title, index) => {
      const summaryLine = document.createElement("li");

      const titleFormatted = title.innerHTML.replace('<br>', '');

      summaryLine.innerHTML = titleFormatted;
      summaryLine.setAttribute("data-index", index);

      summaryList.appendChild(summaryLine);
    });

    policyBody.prepend(summary);

    const summaryLines = document.querySelectorAll(".shopify-policy__summary li");
    summaryLines.forEach((summaryLine, index) => {
      summaryLine.addEventListener("click", () => {
        const indexToOpen = parseInt(summaryLine.getAttribute("data-index"));
        const policyContent = allTitles[indexToOpen];

        policyContent.scrollIntoView();
      });
    });
  }
}

